<template>
  <div class="container_box">
    <Tabs v-model="pageParams.status" :animated="false" class="tabs_styles" @on-click="search()">
      <TabPane v-for="item in statusList" :label="item.title" :name="item.value.toString()"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="pageParams.status === 'null'">
            <Form-item :label="$t('key1003828')" prop="billStatus">
              <Select v-model="pageParams.billStatus" multiple>
                <Option v-for="item in billStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003594')">
              <Date-picker
                type="datetimerange"
                class="wid100P"
                @on-clear="resetDate('establish')"
                @on-change="(value) => getDateValue(value, 'establish')"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="billingTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003593')">
              <Date-picker
                type="datetimerange"
                class="wid100P"
                :options="dateOptions"
                @on-clear="resetDate('cycle')"
                @on-change="(value) => getDateValue(value, 'cycle')"
                :clearable="true"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="cycleTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002820')" prop="searchValue">
              <Input :placeholder="$t('key1003829')" v-model.trim="pageParams.searchValue" clearable></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--批量审核-->
      <Button class="mr15" v-if="['null', '1'].includes(pageParams.status) && getPermission('ymsSupplierBill_approved')"
        type="primary" @click="auditConfirmationBtn('all')">{{ $t('key1003204') }}
      </Button>
      <!--批量打款-->
      <Button class="mr15" v-if="['null', '3'].includes(pageParams.status) && getPermission('ymsSupplierBill_receiveConfirm')"
        type="primary" @click="billPaymentBtn('all')">{{ $t('key1003831') }}
      </Button>
      <!--批量确认线下打款-->
      <Button class="mr15" v-if="['null', '3'].includes(pageParams.status) && getPermission('ymsSupplierBill_receiveConfirm')"
        type="primary" @click="confirmCollectionBtn('all')">{{ $t('key1003832') }}
      </Button>
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsSupplierBill_exportSupplierBill') ||
      getPermission('ymsSupplierBillPackageDetail_exportBillDetail')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="530"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-sort-change="sortChange"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--账单打款确认提示框-->
    <billPaymentModal
      ref="billPayment"
      @auditConfirmationChange="auditConfirmationChange"
      :selectTableData="selectTableData"
      :ymsBillId="ymsBillId"
      @updateData="search">
    </billPaymentModal>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1003830')"
      paramKeyColums="ymsSupplierBillDetailExportHandlerColumns"
      :customFieldExportList="customFieldExportList"
      :dimensionTypeList="dimensionTypeList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :logType="['SYSTEM_LOG', 'SUPPLIER_LOG']" :showPage="true"></commonLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import billPaymentModal from "@/views/yms/components/financialManage/billPaymentModal";
import dropDownFilter from "@/components/common/dropDownFilter.vue";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import {getUserNameByUserId, pageJump, commonSessionStorage, getAllUsersInfo, getDataSetBatchList, getEnumList, getEnumName} from "@/utils/common";
import commonLogModal from "@/components/common/commonLogModal.vue";

export default {
  name: 'supplierBill',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      billingTime: [],
      cycleTime: [],
      pageParams: {
        createdStartTime: null,
        createdEndTime: null,
        periodStartTime: null,
        periodEndTime: null,
        businessMerchantIds: '',
        searchValue: '',
        billStatus: [],
        billNos: '',
        status: '1',  // null 全部、 1 待审核状态、 2 待确认 、3 等待收款/付款、 4 已收款/已付款 、5 作废
        pageNum: 1,
        pageSize: 15,
        orderBy: 'createdTime',
        upDown: 'down',
      },
      total: 0,
      tableColumns: [],
      tableData: [],
      selectTableData: [],
      ymsBillId: null,
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002805'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002806'), parameterKey: 'businessMerchantIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003799'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003800'), parameterKey: 'billNos'},
      ],
      defaultSelectValue: 1,
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003620'),
          titleKey: 'billingInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1], paramKey: 'billNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003799')},
            {type: [1], paramKey: 'periodTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613')},
            {type: [1], paramKey: 'supplierName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101')},
            {type: [1], paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {type: [1], paramKey: 'totalPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003801')},
            {type: [1], paramKey: 'currency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003802')},
            {type: [1], paramKey: 'packageQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803')},
            {type: [1], paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003804')},
            {type: [1], paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003619')},
            {type: [1], paramKey: 'supplierConfirmTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003805')},
            {type: [1], paramKey: 'checkTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003806')},
            {type: [1], paramKey: 'checkBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002952')},
            {type: [1], paramKey: 'paymentTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003807')},
            {type: [1], paramKey: 'paymentBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003808')},
            {type: [1], paramKey: 'paymentType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003809')}
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003810'),
          titleKey: 'receivingAccountInfoColums',
          selectList: [],
          checkBoxList: [
            {type: [1], paramKey: 'payType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002860')},
            {type: [1], paramKey: 'payAccountName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002862')},
            {type: [1], paramKey: 'issuingBank', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003811')},
            {type: [1], paramKey: 'payAccountNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003812')},
            {type: [1], paramKey: 'idCard', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003813')}
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003814'),
          titleKey: 'billDetailsInfoColums',
          selectList: [],
          checkBoxList: [
            {type: [2], paramKey: 'billNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003799')},
            {type: [2], paramKey: 'supplierName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101')},
            {type: [2], paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {type: [2], paramKey: 'type', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003655')},
            {type: [2], paramKey: 'relatedBusinessId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003754'), disabled: true},
            {type: [2], paramKey: 'supplierSpu', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001093')},
            {type: [2], paramKey: 'SupplierSku', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586')},
            {type: [2], paramKey: 'quantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003656')},
            {type: [2], paramKey: 'suggestPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003815')},
            {type: [2], paramKey: 'totalAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003816')},
            {type: [2], paramKey: 'currency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000738')},
            {type: [2], paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003817')},
            {type: [2], paramKey: 'labelType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003818')},
            {type: [2], paramKey: 'packageCreatedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003663')},
            {type: [2], paramKey: 'shipedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003819')},
            {type: [2], paramKey: 'needPurchase', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003820')},
            {type: [2], paramKey: 'supplierDeliveryLogisticsFee', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003821')},
            {type: [2], paramKey: 'domesticLogisticsFee', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003822')},
            {type: [2], paramKey: 'totalPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003823')},
          ]
        }
      ],
      userInfoList: {},
      enumData: []
    };
  },
  computed: {
    filterKeyList() {
      let parameterKeyList = this.dropDownInputList.map((item) => {
        return item.parameterKey;
      });
      return parameterKeyList;
    },
    dimensionTypeList() {
      let list = [
        {value: 1, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003824'), permissionKey: 'ymsSupplierBill_exportSupplierBill'},
        {value: 2, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003610'), permissionKey: 'ymsSupplierBillPackageDetail_exportBillDetail'}
      ];
      list.map((item) => {
        item['show'] = this.getPermission(item.permissionKey);
      });
      return list;
    },
    billStatusList() {
      const ENUM_KEY = 'YmsBillStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY);
      return list;
    },
    statusList() {
      const ENUM_KEY = 'YmsBillStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY);
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    }
  },
  created() {
    let status = commonSessionStorage.getItem('tabStatus');
    if (status) {
      this.pageParams.status = status;
    }
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        let enumKeyList = ['YmsBillStatusCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        this.userInfoList = await getAllUsersInfo();
        await this.getList();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.selectTableData = [];
      v.$refs['pageParams'].resetFields();
      v.billingTime = [];
      v.changeInput(1);
      v.resetDate('establish');
      v.resetDate('cycle');
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let {billStatus, ...obj} = v.pageParams;
      let params = Object.assign({}, obj);
      if (v.pageParams.status === 'null') {
        params.status = billStatus;
      } else {
        params.status = [Number(params.status)];
      }
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.selectTableData = [];
      v.tableData = [];
      v.total = 0;
      v.$nextTick(() => {
        v.$refs['selection'].selectAll(false);
      });
      if (v.getPermission('ymsSupplierBill_query')) {
        v.tableLoading = true;
        v.axios.post(api.yms_post_ymsSupplierBill_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            commonSessionStorage.removeItem('tabStatus');
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              v.tableData = v.handleMultilinguaTableFields(list, ['businessMerchantName']);
              v.updateTableDom('selection');
              v.total = data.total;
              v.$forceUpdate();
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 获取时间
    getDateValue(value, type) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate(type);
      } else {
        if (!value[0]) {
          v.resetDate(type);
        } else {
          let timeList = v.defaultTimePeriod(value);
          if (type === 'establish') {
            v.billingTime = v.defaultTimePeriod(value, false);
            v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
            v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
          } else if (type === 'cycle') {
            v.cycleTime = v.defaultTimePeriod(value, false);
            v.pageParams.periodStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
            v.pageParams.periodEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
          }
        }
      }
    },
    // 重置时间
    resetDate(type) {
      switch (type) {
        case 'establish':
          this.billingTime = [];
          this.pageParams.createdStartTime = null;
          this.pageParams.createdEndTime = null;
          break;
        case 'cycle':
          this.cycleTime = [];
          this.pageParams.periodStartTime = null;
          this.pageParams.periodEndTime = null;
          break;
      }
    },
    // 批量、确认打款按钮
    billPaymentBtn(type) {
      let v = this;
      v.$refs['billPayment'].getSetPassword().then(() => {
        if (type === 'all') {
          if (v.selectTableData.length > 0) {
            let talg = v.selectTableData.every((item) => {
              return item.payType === 2;
            });
            if (talg) {
              v.$refs['billPayment'].billPaymentModal = true;
            } else {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003825'));
              return false;
            }
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003826'));
            return false;
          }
        } else {
          v.$refs['billPayment'].billPaymentModal = true;
        }
      });
    },
    // 批量、线下已打款按钮
    confirmCollectionBtn(type, ymsBillId) {
      let v = this;
      let ymsBillIds = [];
      if (type === 'all') {
        if (v.selectTableData.length > 0) {
          ymsBillIds = v.selectTableData;
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003826'));
          return false;
        }
      } else {
        ymsBillIds = [ymsBillId];
      }
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003679'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003680'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003681'),
        onOk: () => {
          v.axios.post(api.post_ymsSupplierBill_batchReceiveConfirmOffLine, ymsBillIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 批量、审核确认按钮
    auditConfirmationBtn(type, ymsBillId) {
      let v = this;
      let ymsBillIds = [];
      if (type === 'all') {
        if (v.selectTableData.length > 0) {
          ymsBillIds = v.selectTableData;
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003826'));
          return false;
        }
      } else {
        ymsBillIds = [ymsBillId];
      }
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003676'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003677'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003678'),
        onOk: () => {
          v.axios.post(api.post_ymsSupplierBill_batchApproved, ymsBillIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 处理列表字段
    handleColumns(value) { // 1 待审核状态 2 待确认 3 等待收款/付款 4 已收款/已付款 5 作废
      let v = this;
      v.optionBtnWidth = [];
      let columns = [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          key: 'selection',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003799'),
          key: 'billNo',
          align: 'center',
          minWidth: 160,
          fixed: 'left',
          sortable: 'custom',
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.billNo
              },
              on: {
                AlinkBtn: () => {
                  const {href} = v.$router.resolve({
                    path: '/supplierBillDetails',
                    query: {
                      ymsBillId: params.row.ymsBillId,
                      status: v.pageParams.status
                    }
                  });
                  window.open(href, '_blank');
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003827'),
          key: 'alipayOrderId',
          width: 140,
          align: 'center',
          render(h, params) {
            let alipayOrderId = params.row.alipayOrderId || '-';
            return h('span', alipayOrderId);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613'),
          key: 'billingCycle',
          align: 'center',
          width: 210,
          render: (h, params) => {
            let time = '';
            let startTime = params.row.periodStartTime;
            let endTime = params.row.periodEndTime;
            if (startTime && endTime) {
              let periodStartTime = v.$uDate.dealTime(startTime);
              let periodEndTime = v.$uDate.dealTime(endTime, 'fulltime');
              // 结束时间减一秒
              let handlerTime = new Date(periodEndTime);
              let newTime = new Date(periodEndTime);
              let timer = handlerTime.getTime();
              newTime.setTime(timer - 1000);
              let newEndTime = new Date(newTime);
              time = periodStartTime + ' - ' + v.$uDate.getDateTime(newEndTime);
            }
            return h('div', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'),
          key: 'businessMerchantName',
          align: 'center',
          minWidth: 220,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'businessMerchantId',
          sortable: 'custom',
          align: 'center',
          minWidth: 150,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003801'),
          key: 'price',
          align: 'center',
          minWidth: 200,
          render: (h, params) => {
            let price = params.row.totalPrice ? params.row.totalPrice : '';
            let currency = params.row.currency ? params.row.currency : '';
            return h('div', {class: 'flex align-items-center justify-content-center'}, [
              h('div', v.formatCurrency(price)),
              currency ? h('div', '（' + currency + '）') : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003803'),
          key: 'packageQuantity',
          align: 'center',
          minWidth: 110
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003804'),
          key: 'status',
          align: 'center',
          minWidth: 130,
          render: (h, params) => {
            let status = params.row.status;
            let title = getEnumName(v.enumData, 'YmsBillStatusCoreEnum', status, 'number');
            return h('div', title);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003619'),
          key: 'createdTime',
          align: 'center',
          sortable: 'custom',
          sortType: 'desc',
          width: 180,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003805'),
          key: 'supplierConfirmTime',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.supplierConfirmTime, 'fulltime') || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003806'),
          key: 'checkTime',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.checkTime, 'fulltime') || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002952'),
          key: 'checkBy',
          width: 130,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.checkBy, v.userInfoList) || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003807'),
          key: 'paymentTime',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.paymentTime, 'fulltime') || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003808'),
          key: 'paymentBy',
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.paymentBy, v.userInfoList) || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003809'),
          key: 'paymentType',
          width: 130,
          align: 'center',
          render: (h, params) => {
            let text = '';
            let paymentType = params.row.paymentType;
            paymentType === 1 ? text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002692') : paymentType === 2 ? text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001833') : text = '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 200,
          fixed: 'right',
          render(h, params) {
            let ymsBillId = params.row.ymsBillId;
            let payType = params.row.payType; // 1 银行卡  2 支付宝
            let status = params.row.status;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000296'),
                    show: v.getPermission('ymsSupplierBill_detail'),
                    clickFn: () => {
                      const {href} = v.$router.resolve({
                        path: '/supplierBillDetails',
                        query: {
                          ymsBillId: ymsBillId,
                          status: v.pageParams.status
                        }
                      });
                      window.open(href, '_blank');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003678'),
                    show: status === 1 && v.getPermission('ymsSupplierBill_approved'),
                    clickFn: () => {
                      v.auditConfirmationBtn('single', ymsBillId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002041'),
                    show: status === 3 && v.getPermission('ymsSupplierBill_receiveConfirm') && payType === 2,
                    clickFn: () => {
                      v.ymsBillId = ymsBillId;
                      v.billPaymentBtn('single');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003684'),
                    show: status === 3 && v.getPermission('ymsSupplierBill_receiveConfirm'),
                    clickFn: () => {
                      v.confirmCollectionBtn('single', ymsBillId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsBillId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      let hideKeyList = [];
      if (value === '1') {
        hideKeyList = ['alipayOrderId', 'checkTime', 'checkBy', 'paymentTime', 'paymentBy', 'paymentType'];
      }
      if (value === '2') {
        hideKeyList = ['alipayOrderId', 'supplierConfirmTime', 'checkTime', 'checkBy', 'paymentTime', 'paymentBy', 'paymentType'];
      }
      if (value === '3') {
        hideKeyList = ['alipayOrderId', 'paymentTime', 'paymentBy', 'paymentType'];
      }
      if (['null', '4'].includes(value)) {
        hideKeyList = [];
      }

      v.tableColumns = columns.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
      v.$forceUpdate();
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsBillId;
        });
      }
    },
    // 监听弹窗
    auditConfirmationChange(value) {
      if (!value) {
        this.$refs['selection'].selectAll(false);
      }
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsBillIds = v.selectTableData;
      } else {
        query.ymsBillIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          let dimensionType = data.dimensionType;
          let url = dimensionType === 1 ? api.post_ymsSupplierBill_exportSupplierBill : api.post_ymsSupplierBillPackageDetail_exportBillDetail;
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    'pageParams.status': {
      handler(value) {
        this.handleColumns(value);
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    commonLogModal,
    exportFieldsModal,
    dropDownFilter,
    billPaymentModal
  }
};
</script>

<style lang="less" scoped>
.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 0;
    margin: 0;
  }
}
</style>
